module.exports = "<div class=\"kan-mails-container\">\n    <div class=\"kan-mails-actions kan-row-no-warp\">\n        <div class=\"kan-col\">\n        </div>\n        <div class=\"kan-col-nogrow\">\n            <button mat-button color=\"primary\"\n                    (click)=\"newMail($event)\">\n                {{'MAILS.ADD' | translate}}\n            </button>\n        </div>\n    </div>\n    <kan-mail-list [mails]=\"mails\"\n                   (refresh)=\"getMails()\">\n    </kan-mail-list>\n</div>\n\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/mails/components/mails/component.html
// module id = ./src/modules/mails/components/mails/component.html
// module chunks = main